import shapeType from '@/enums/ShapeType';
import { Jonctions } from '@/enums/jonctions';

export default {
  state: {
    shapeList: [],
    buildingMeasurements: [],
    globalTable: {
      solin: 0,
      contreSolin: 0,
      noues: 0,
      faite: 0,
      aretier: 0,
      descenteGouttiere: 0,
      largeurSoffite: 0,
      ajustementIsolationEntreToit: 0,
      ajustementBaseVersant: 0,
      ajustementMoulureDepart: 0,
      ajustementSolin: 0,
      ajustementNoues: 0,
      ajustementFaite: 0,
      ajustementArretier: 0,
      ajustementGouttieres: 0,
      ajustementSoffiteCalcule: 0,
      ajustementFermeDeToit: 0,
    },
    shapeId: 0,
  },
  getters: {
    getShapeList: state => state.shapeList,
    getShapelistHasValue: state => state.shapeList.length,
    getShape: state => index => state.shapeList.find(x => x.id === index),
    getShapeId: state => state.shapeId,
    getSurfaceReelle: state => {
      const reducer = (acc, vc) => acc + parseFloat(vc.surface);
      return state.shapeList.reduce(reducer, 0);
    },
    getSurfaceTotal: state => {
      const reducer = (acc, vc) => acc + parseFloat(vc.surfaceTotale);
      return state.shapeList.reduce(reducer, 0);
    },
    getSurfaceTotalWithIsolation: state => {
      const filteredList = state.buildingMeasurements.filter(x => x.isolation === true);
      const reducer = (acc, vc) => acc + parseFloat(vc.longueur) * parseFloat(vc.largeur);
      return filteredList.reduce(reducer, 0);
    },
    getSurfaceTotalWithFermeDeToit: state => {
      const filteredList = state.buildingMeasurements.filter(x => x.fermeDeToit === true);
      const reducer = (acc, vc) => acc + parseFloat(vc.longueur) * parseFloat(vc.largeur);
      return filteredList.reduce(reducer, 0);
    },
    getSommeLongueurVersant: state => {
      const reducer = (acc, vc) => acc + parseFloat(vc.getBaseVersant(vc));
      return state.shapeList.reduce(reducer, 0);
    },
    getSommeLongueurCalculee: state => {
      const reducer = (acc, vc) => acc + parseFloat(vc.longueureCalculee) * vc.nbVersants;
      return state.shapeList.reduce(reducer, 0);
    },
    getSommeMoulure: (state, getters) => {
      const reducer = (acc, vc) => acc + vc.calculMoulure(vc);
      return getters.getShapeList.reduce(reducer, 0);
    },
    getSommeVentilateurToit: state => {
      const reducer = (acc, vc) => acc + parseFloat(vc.ventilateurToit);
      return state.shapeList.reduce(reducer, 0);
    },
    getSommeFaite: (state, getters) => {
      const reducer = (acc, vc) => acc + vc.calculFaite(vc);
      return getters.getShapeList.reduce(reducer, 0);
    },
    getSommeArretier: (state, getters) => {
      const reducer = (acc, vc) => acc + vc.calculArretier(vc) * vc.nbVersants;
      return getters.getShapeList.filter(x => x.jonction === Jonctions.ARRETIER).reduce(reducer, 0);
    },
    getSommeNoues: (state, getters) => {
      const reducer = (acc, vc) => acc + vc.calculArretier(vc) * vc.nbVersants;
      return getters.getShapeList.filter(x => x.jonction === Jonctions.NOUE).reduce(reducer, 0);
    },
    getSommeSolins: (state, getters) => {
      const reducer = (acc, vc) => acc + vc.calculArretier(vc) * vc.nbVersants;
      return (
        getters.getSommeNoues + getters.getShapeList.filter(x => x.jonction === Jonctions.SOLIN).reduce(reducer, 0)
      );
    },
    getCalculSoffite: state => {
      const reducer = (acc, vc) => acc + parseFloat((vc.calculMoulure(vc) * vc.largeurSoffite) / 12);
      return state.shapeList.reduce(reducer, 0);
    },
    getSerializedData: state => JSON.stringify(state),
    mapToTaskObj: (state, getters) => ({
      id: 130,
      referenceName: 'toit_pente',
      isFloorMeasurement: false,
      totals: {
        pente_isolation_entretoit:
          getters.getSurfaceTotalWithIsolation + (parseFloat(state.globalTable.ajustementIsolationEntreToit) || 0),
        pente_ferme_toit:
          getters.getSurfaceTotalWithFermeDeToit + (parseFloat(state.globalTable.ajustementFermeDeToit) || 0),
        pente_surface_totale: getters.getSurfaceTotal,
        pente_base_versant:
          getters.getSommeLongueurVersant + (parseFloat(state.globalTable.ajustementBaseVersant) || 0),
        pente_moulure_depart: getters.getSommeMoulure + (parseFloat(state.globalTable.ajustementMoulureDepart) || 0),
        pente_noue: (parseFloat(getters.getSommeNoues) || 0) + (parseFloat(state.globalTable.ajustementNoues) || 0),
        pente_faite: parseFloat(getters.getSommeFaite || 0) + parseFloat(state.globalTable.ajustementFaite || 0),
        pente_arretier:
          (parseFloat(getters.getSommeArretier) || 0) + (parseFloat(state.globalTable.ajustementArretier) || 0),
        pente_ventilateur_toit: getters.getSommeVentilateurToit,
        pente_soffite: getters.getCalculSoffite + (parseFloat(state.globalTable.ajustementSoffiteCalcule) || 0),
        pente_gouttiere:
          getters.getSommeLongueurVersant +
          parseFloat(state.globalTable.descenteGouttiere) +
          (parseFloat(state.globalTable.ajustementGouttieres) || 0),
        pente_solin: (parseFloat(getters.getSommeSolins) || 0) + (parseFloat(state.globalTable.ajustementSolin) || 0),
        pente_contre_solin: parseFloat(state.globalTable.contreSolin) || 0,
        pente_surface_total_avant_perte: getters.getSurfaceReelle,
      },
      measures: getters.getSerializedData,
    }),
    getBuildingMeasurements: state => state.buildingMeasurements,
    getBuildingMeasurementById: state => id => state.buildingMeasurements[id],
    getSurfaceBuildingMeasureById: (state, getters) => id => {
      let measure = getters.getBuildingMeasurementById(id);
      return measure.longueur * measure.largeur;
    },
    getSurfaceTotalBuildingMeasure: (state, getters) => {
      const reducer = (acc, vc, id) => acc + getters.getSurfaceBuildingMeasureById(id);
      return getters.getBuildingMeasurements.reduce(reducer, 0);
    },
  },
  mutations: {
    pushState: (state, payload) => {
      const tempState = JSON.parse(payload);
      state.buildingMeasurements = tempState.buildingMeasurements;
      state.shapeList = tempState.shapeList;
      state.shapeList.forEach(element => {
        const tempShape = shapeType.getNewShapeByName(element.name.toLowerCase().replace(' ', ''));
        element.formule = tempShape.formule;
        element.calculMoulure = tempShape.calculMoulure;
        element.calculArretier = tempShape.calculArretier;
        element.calculFaite = tempShape.calculFaite;
        element.getBaseVersant = tempShape.getBaseVersant;
      });
      state.globalTable = tempState.globalTable;
      state.shapeId = tempState.shapeId;
    },
    pushShape: (state, payload) => {
      const rawShape = shapeType.ShapeTypes[payload.item.type].getNewShape();
      rawShape.id = payload.id;
      rawShape.nbVersants = rawShape.nbVersants ? rawShape.nbVersants : payload.item.versants;
      state.shapeList.push(rawShape);
    },
    incrementShapeId: state => {
      state.shapeId++;
    },
    removeShape: (state, id) => {
      state.shapeList = state.shapeList.filter(x => x.id !== id);
    },
    resetState: state => {
      state.shapeList = [];
      state.shapeId = 0;
      state.buildingMeasurements = [];
      state.globalTable = {
        solin: 0,
        contreSolin: 0,
        noues: 0,
        faite: 0,
        aretier: 0,
        descenteGouttiere: 0,
        largeurSoffite: 0,
        ajustementIsolationEntreToit: 0,
        ajustementBaseVersant: 0,
        ajustementMoulureDepart: 0,
        ajustementSolin: 0,
        ajustementNoues: 0,
        ajustementFaite: 0,
        ajustementArretier: 0,
        ajustementGouttieres: 0,
        ajustementSoffiteCalcule: 0,
        ajustementFermeDeToit: 0,
      };
    },
    pushBuildingMeasurement: (state, payload) => {
      state.buildingMeasurements.push(payload);
    },
    removeBuildingMeasurement: (state, id) => {
      state.buildingMeasurements.splice(id, 1);
    },
  },
  actions: {
    addShapeList({ commit, getters }, payload) {
      for (let element of payload) {
        commit('pushShape', { item: element, id: getters.getShapeId });
        commit('incrementShapeId');
      }
    },
    addShape({ commit, getters }, payload) {
      commit('pushShape', { item: payload, id: getters.getShapeId });
      commit('incrementShapeId');
    },
    addBuildingMeasurement({ commit }) {
      commit('pushBuildingMeasurement', {
        longueur: 0,
        largeur: 0,
        isolation: false,
        fermeDeToit: false,
      });
    },
  },
};
